(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracSourceTypeDialogController', NasracSourceTypeDialogController);

    NasracSourceTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NasracSourceType'];

    function NasracSourceTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NasracSourceType) {
        var vm = this;

        vm.nasracSourceType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.nasracSourceType.id !== null) {
                NasracSourceType.update(vm.nasracSourceType, onSaveSuccess, onSaveError);
            } else {
                NasracSourceType.save(vm.nasracSourceType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:nasracSourceTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
